import { render } from "./casualQues.vue?vue&type=template&id=526b9fc6"
import script from "./casualQues.vue?vue&type=script&lang=js"
export * from "./casualQues.vue?vue&type=script&lang=js"

import "./casualQues.vue?vue&type=style&index=0&id=526b9fc6&lang=scss"

import exportComponent from "C:\\Users\\pzx\\Desktop\\Master\\im\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__